import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,

	Grid,
	Backdrop,
	IconButton,
	CircularProgress,
} from "@mui/material";
import {
	withStyles
} from "@mui/styles";
import {
	Close as CloseIcon
} from "@mui/icons-material";
import ImageGallery from "react-image-gallery";
import {VideoPreview} from "../index";
import {
	Notification,
	notificationTypes
} from "../../common/Notification";
import optimizationImageVideo, {compressImage} from "../../common/OptimizationImageVideo";
import {clipboardWriteText} from "../../common/Clipboard";
import {palette} from "../../theme/common";

class DialogImagesVideos extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			files: [],

			activeIndex: 0,

			isOpen: false,
			isBackdrop: false,
		}
		this.refImageGallery = React.createRef();
	}

	open = ({ files, activeIndex }) => {
		files = files.map((file) => {
			const isVideo = Boolean((file?.file?.type||file?.mimetype||"").includes("video"));
			const _getFileUrl = () => {
				if (file?.fileUrl) {
					return file?.fileUrl
				}
				return URL.createObjectURL(file.file)
			}

			if (isVideo) {
				return {
					file: file,
					original: _getFileUrl(),
					thumbnail: _getFileUrl(),
					renderItem: this.renderVideo.bind(this, file),
					renderThumbInner: this.videoThumbInner.bind(this, file)
				}
			}

			return {
				file: file,
				original: _getFileUrl(),
				thumbnail: _getFileUrl()
			}
		})

		this.setState({
			files,
			activeIndex,

			isOpen: true
		})
	}
	close = () => {
		this.setState({
			isOpen: false
		})
	}

	videoThumbInner = (videoItem) => {
		return (
			<div>
				<VideoPreview
					file={videoItem}
				/>
			</div>
		)
	}
	renderVideo = (file) => {
		const link = file?.fileUrl || URL.createObjectURL(file?.file) || "";
		return (
			<div>
				<video autoPlay={false} width="100%" controls>
					<source src={link} />
				</video>
			</div>
		);
	}

	shareItem = async () => {
		const { files } = this.state;
		const currentIndex = this.refImageGallery.current.state?.currentIndex || 0;
		const element = files[currentIndex];
		const fileUrl = element?.original;

		clipboardWriteText(fileUrl);
		Notification({
			type: notificationTypes.success,
			message: "Ссылка на файл успешно скопирована"
		})
	}

	renderCustomControls = () => {
		return (
			<div className="dialog-images-videos__additional_control">
				<IconButton onClick={this.shareItem.bind(this)} sx={{background: "#F3F5F9", borderRadius: "4px"}}>
					<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd"
						      d="M6.80006 1.25H6.76796C5.95512 1.24999 5.2995 1.24999 4.76859 1.29336C4.22196 1.33803 3.74182 1.43238 3.2976 1.65873C2.59199 2.01825 2.01831 2.59193 1.65879 3.29754C1.43245 3.74175 1.33809 4.22189 1.29342 4.76853C1.25005 5.29944 1.25005 5.95506 1.25006 6.7679V6.8V11.2V11.2321C1.25005 12.0449 1.25005 12.7006 1.29342 13.2315C1.33809 13.7781 1.43245 14.2582 1.65879 14.7025C2.01831 15.4081 2.59199 15.9817 3.2976 16.3413C3.74182 16.5676 4.22196 16.662 4.76859 16.7066C5.2995 16.75 5.95511 16.75 6.76794 16.75H6.80006H7.25006V17.2V17.2321C7.25005 18.0449 7.25005 18.7006 7.29342 19.2315C7.33809 19.7781 7.43245 20.2582 7.65879 20.7025C8.01831 21.4081 8.59199 21.9817 9.2976 22.3413C9.74182 22.5676 10.222 22.662 10.7686 22.7066C11.2995 22.75 11.9551 22.75 12.768 22.75H12.8001H17.2001H17.2321C18.045 22.75 18.7006 22.75 19.2315 22.7066C19.7782 22.662 20.2583 22.5676 20.7025 22.3413C21.4081 21.9817 21.9818 21.4081 22.3413 20.7025C22.5677 20.2582 22.662 19.7781 22.7067 19.2315C22.7501 18.7006 22.7501 18.0449 22.7501 17.2321V17.2V12.8V12.7679C22.7501 11.9551 22.7501 11.2994 22.7067 10.7685C22.662 10.2219 22.5677 9.74175 22.3413 9.29754C21.9818 8.59193 21.4081 8.01825 20.7025 7.65873C20.2583 7.43238 19.7782 7.33803 19.2315 7.29336C18.7006 7.24999 18.045 7.24999 17.2322 7.25H17.2001H16.7501V6.8V6.76788C16.7501 5.95505 16.7501 5.29944 16.7067 4.76853C16.662 4.22189 16.5677 3.74175 16.3413 3.29754C15.9818 2.59193 15.4081 2.01825 14.7025 1.65873C14.2583 1.43238 13.7782 1.33803 13.2315 1.29336C12.7006 1.24999 12.045 1.24999 11.2322 1.25H11.2001H6.80006ZM16.7501 8.75V11.2V11.2321C16.7501 12.045 16.7501 12.7006 16.7067 13.2315C16.662 13.7781 16.5677 14.2582 16.3413 14.7025C15.9818 15.4081 15.4081 15.9817 14.7025 16.3413C14.2583 16.5676 13.7782 16.662 13.2315 16.7066C12.7006 16.75 12.045 16.75 11.2322 16.75H11.2001H8.75006V17.2C8.75006 18.0525 8.75064 18.6467 8.78844 19.1093C8.82553 19.5632 8.89466 19.824 8.9953 20.0215C9.21101 20.4448 9.55522 20.789 9.97858 21.0048C10.1761 21.1054 10.4369 21.1745 10.8907 21.2116C11.3534 21.2494 11.9476 21.25 12.8001 21.25H17.2001C18.0525 21.25 18.6467 21.2494 19.1094 21.2116C19.5633 21.1745 19.824 21.1054 20.0215 21.0048C20.4449 20.789 20.7891 20.4448 21.0048 20.0215C21.1055 19.824 21.1746 19.5632 21.2117 19.1093C21.2495 18.6467 21.2501 18.0525 21.2501 17.2V12.8C21.2501 11.9475 21.2495 11.3533 21.2117 10.8907C21.1746 10.4368 21.1055 10.176 21.0048 9.97852C20.7891 9.55516 20.4449 9.21095 20.0215 8.99524C19.824 8.8946 19.5633 8.82546 19.1094 8.78838C18.6467 8.75058 18.0525 8.75 17.2001 8.75H16.7501ZM3.97858 2.99524C4.1761 2.8946 4.43687 2.82546 4.89074 2.78838C5.35337 2.75058 5.94761 2.75 6.80006 2.75H11.2001C12.0525 2.75 12.6467 2.75058 13.1094 2.78838C13.5633 2.82546 13.824 2.8946 14.0215 2.99524C14.4449 3.21095 14.7891 3.55516 15.0048 3.97852C15.1055 4.17604 15.1746 4.4368 15.2117 4.89068C15.2495 5.35331 15.2501 5.94755 15.2501 6.8V11.2C15.2501 12.0525 15.2495 12.6467 15.2117 13.1093C15.1746 13.5632 15.1055 13.824 15.0048 14.0215C14.7891 14.4448 14.4449 14.789 14.0215 15.0048C13.824 15.1054 13.5633 15.1745 13.1094 15.2116C12.6468 15.2494 12.0525 15.25 11.2001 15.25H6.80006C5.94761 15.25 5.35337 15.2494 4.89074 15.2116C4.43687 15.1745 4.1761 15.1054 3.97858 15.0048C3.55522 14.789 3.21101 14.4448 2.9953 14.0215C2.89466 13.824 2.82553 13.5632 2.78844 13.1093C2.75064 12.6467 2.75006 12.0525 2.75006 11.2V6.8C2.75006 5.94755 2.75064 5.35331 2.78844 4.89068C2.82553 4.4368 2.89466 4.17604 2.9953 3.97852C3.21101 3.55516 3.55522 3.21095 3.97858 2.99524Z"
						      fill="#8698B1"/>
					</svg>
				</IconButton>
			</div>
		)
	}

	render() {
		const {
			files,
			activeIndex,
			isOpen,
			isBackdrop
		} = this.state;
		const {
			classes
		} = this.props;

		return (
			<>

				<Dialog
					open={isOpen}
					fullWidth
					maxWidth="md"
					onClose={this.close}
				>
					<DialogTitle>
						<Grid container justifyContent="flex-end">
							<Grid item>
								<IconButton onClick={this.close}>
									<CloseIcon/>
								</IconButton>
							</Grid>
						</Grid>
					</DialogTitle>
					<DialogContent>
						<div className={classes.root}>
							<ImageGallery
								ref={this.refImageGallery}

								items={files}
								startIndex={activeIndex}
								showPlayButton={false}
								showIndex={true}

								renderCustomControls={this.renderCustomControls}
							/>
						</div>
					</DialogContent>
				</Dialog>

				<Backdrop open={isBackdrop}>
					<CircularProgress/>
				</Backdrop>

			</>
		)
	}
}

const styles = {
	root: {
		"& .fullscreen .image-gallery-slides": {
			"& > *": {
				height: "calc(100vh - 120px)",
			},
		},
		"& .image-gallery-slides": {
			boxShadow: "0px 3px 5px 0px #00000014",
			borderRadius: "12px",

			"& > *": {
				display: "flex!important",
				alignItems: "center",
				justifyContent: "center",
				height: "640px",
			},
			"& > * > *": {
				display: "flex",
				maxHeight: "100%!important"
			},
			"& video": {
				maxHeight: "100%"
			}
		},
		"& .image-gallery-index": {
			background: "#F3F5F9",
			top: "12px",
			right: "12px",
			borderRadius: "8px",
			color: "#8698B1",
			padding: "10px 20px",
		},

		"& .image-gallery-thumbnails-container": {
			display: 'flex',
			alignItems: 'center',
			marginTop: 10
		},
		"& .image-gallery-thumbnail": {
			height: 64,
			width: 120,
			border: "1px solid transparent",

			borderRadius: 4,
			overflow: "hidden",

			"& > *": {
				display: "flex",
				alignItems: 'center',
				justifyContent: "center",
				height: "100%"
			},
			"& img, & video": {
				width: "100%",
				height: "100%",
				objectFit: 'cover',
				objectPosition: 'center',
			},
			"&.active": {
				borderColor: palette.primary.main,
			}
		}
	}
};
DialogImagesVideos = withStyles(styles)(DialogImagesVideos);

export default DialogImagesVideos
